// Function to fetch images from NGC based on cert number
export const fetchCertImages = async (certNumber, certService, grade = undefined, existingCertInfo = null) => {
  try {
    console.log('Fetching cert images:', {
      certNumber,
      certService,
      grade
    });

    let images = [];

    // Convert numeric service ID to name if needed
    // Map IDs to names based on certification_services table
    const serviceName = typeof certService === 'number' 
      ? { 1: 'PCGS', 2: 'NGC', 3: 'CACG', 4: 'Other', 5: 'ANACS', 6: 'ICG', 7: 'ACCA', 8: 'CAG' }[certService] 
      : certService.toUpperCase();

    // Early return if service doesn't support image downloading
    const servicesWithImageSupport = ['PCGS', 'NGC', 'CACG', 'ANACS', 'ACCA', 'CAG'];
    if (!servicesWithImageSupport.includes(serviceName)) {
      console.log(`${serviceName} does not support image downloading`);
      return [];
    }

    console.log('Service name:', serviceName);

    // Use existing cert info if available for any service
    if (existingCertInfo?.images) {
      console.log('Using existing cert info for', serviceName);
      const imageData = existingCertInfo.images;
      images.push(...imageData.map(img => ({
        image_url: img.url,
        image_type: img.type
      })));
      console.log(`${serviceName} images found:`, {
        total: imageData.length,
        images
      });
    } else if (serviceName === 'NGC') {
      // Fallback to API call if no existing data for NGC
      console.log('Fetching NGC images from API');
      const { certLookup } = await import('./api');
      
      // Handle special grades for NGC
      let lookupGrade = grade;
      if (grade === 'Details' || grade === 'Ancients') {
        lookupGrade = null; // Don't pass special grades to the API
      }
      
      const response = await certLookup.lookup('ngc', certNumber, lookupGrade);
      console.log('NGC lookup response:', response);
      
      if (response.images) {
        images.push(...response.images.map(img => ({
          image_url: img.url,
          image_type: img.type
        })));
        console.log('NGC images found:', {
          total: response.images.length,
          images
        });
      }
    } else if (serviceName === 'PCGS') {
      // Fallback to API call if no existing data for PCGS
      console.log('Fetching PCGS images from API');
      const { certLookup } = await import('./api');
      const response = await certLookup.lookup('pcgs', certNumber);
      console.log('PCGS lookup response:', response);
      
      if (response.images) {
        images.push(...response.images.map(img => ({
          image_url: img.url,
          image_type: img.type
        })));
        console.log('PCGS images found:', {
          total: response.images.length,
          images
        });
      }
    } else {
      // Handle all other services that support images (CAG, CACG, ANACS, ACCA)
      console.log(`Fetching ${serviceName} images from API`);
      const { certLookup } = await import('./api');
      const response = await certLookup.lookup(serviceName.toLowerCase(), certNumber);
      console.log(`${serviceName} lookup response:`, response);
      
      if (response.images) {
        images.push(...response.images.map(img => ({
          image_url: img.url,
          image_type: img.type
        })));
        console.log(`${serviceName} images found:`, {
          total: response.images.length,
          images
        });
      }
    }

    // Images are already verified by the backend API
    console.log('Using pre-verified images from API:', images);
    return images;
  } catch (error) {
    console.error('Error fetching cert images:', error);
    return [];
  }
};
